import { Config } from "@commonlibs";
import { DeepPartial } from "@commonlibs";
import { config } from "common/config";

export const componentsConfig: DeepPartial<Config["components"]> = {
    Drawer: {
        defaultProps: {
            elevation: 0,
        },
    },
    Paper: {
        defaultProps: {
            elevation: 0,
        },
    },
    BlockchainAddress: {
        blockchainLinks: {
            address: `${config.blockchainLinks.explorer}/accounts/`,
            tx: `${config.blockchainLinks.explorer}/transactions/`,
        },
    },
    Image: {
        defaultProps: {
            fallback: config.fallbackImages.defaultImage,
        },
    },
};
